<div class="progress-bar">
   <div *ngIf="progress > 0">
     <progressbar [max]="100" [value]="progress" [type]="progressBarType" [striped]="true" [animate]="true"><i>{{(progress === 100 ? ('Successful download' | translate) : (progress + '%'))}}</i></progressbar>
   </div>
</div>
<lib-table
   *ngIf="canDownloadDocs"
   [headers]="portalHeaders"
   [codes]="portalCodes"
   [rows]="portalReleases"
   [readOnly]="true"
   [search]="false"
   (iconEvent)="onIconClick($event)"
   [label]="'Portal releases' | translate"
>
</lib-table>

<lib-table
   [headers]="appHeaders"
   [codes]="appCodes"
   [rows]="appReleases"
   [readOnly]="true"
   [search]="false"
   (iconEvent)="onIconClick($event)"
   [label]="'Application releases' | translate"
>
</lib-table>
